import { createContext } from "react";


const UserContext= createContext({
    loggedInUser:"Gobu",
});
export default UserContext;
//2:42:53 11th video